<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="4 4 16 16">
    <path
      d="M20 4H18.6L12 10.6L5.4 4H4V5.4L10.6 12L4 18.6V20H5.4L12 13.4L18.6 20H20V18.6L13.4 12L20 5.4V4Z"
      fill="currentColor"
    ></path>
  </svg>
</template>
